<template>
  <div>
    <v-dialog
      :value="dialogAffiliateDetail"
      transition="dialog-bottom-transition"
      max-width="1000px"
      @click:outside="setDialogAffiliateDetail(false)"
    >
      <v-card color="#e9e8ed">
        <v-card-title style="justify-content: space-between">
          <p>{{ $t("reports.sales-by-affiliate.details") }}</p>
          <button @click="setDialogAffiliateDetail(false)">
            <v-icon>mdi-close</v-icon>
          </button>
        </v-card-title>

        <v-card-text>
          <v-form
            @submit.prevent="filterByAffiliate"
            class="search-forms"
            ref="form"
          >
            <v-row>
              <v-col cols="12" md="3" sm="4">
                <date-time-picker
                  :label="$t('reports.initial-date')"
                  @formatted-date="handleInitDateTime"
                ></date-time-picker>
              </v-col>

              <v-col cols="12" md="3" sm="4">
                <date-time-picker
                  :label="$t('reports.final-date')"
                  @formatted-date="handleEndDateTime"
                ></date-time-picker>
              </v-col>

              <v-col class="d-flex justify-end align-end mb-1">
                <BaseButton
                  variant="filter"
                  class="button rounded-xxl"
                  type="submit"
                  :loading="affiliateDetailLoading"
                >
                  {{ $t("reports.filter") }}
                </BaseButton>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-text>
          <v-data-table
            class="rounded-lg"
            :header-props="{
              class: 'rounded-t-lg',
              color: $config.dados.corinputs,
            }"
            :no-data-text="$t('reports.no-info-found')"
            :loading-text="$t('reports.loading-info')"
            :loading="affiliateDetailLoading"
            :headers="headers"
            :items="allAffiliateDetail.info"
            mobile-breakpoint="0"
            :footer-props="{
              class: 'rounded-b-lg',
              itemsPerPageOptions: [10, 20, 50],
              itemsPerPageText: $t(
                'reports.sales-by-affiliate.networks-per-page'
              ),
            }"
          >
            <template v-slot:item.comissao_afiliado="{ item }">
              {{ item.comissao_afiliado | moeda }}
            </template>
            <template v-slot:item.desconto_afiliado="{ item }">
              {{ item.desconto_afiliado | moeda }}
            </template>
            <template v-slot:item.valor_total="{ item }">
              {{ item.valor_total | moeda }}
            </template>

            <template
              v-for="(totais, index) in allAffiliateDetail.totals"
              v-slot:body.append
            >
              <tr :key="index" class="text-end font-weight-bold total-row">
                <td class="text-start">Total</td>
                <v-spacer> </v-spacer>
                <td>{{ totais.comissao_afiliado | moeda }}</td>
                <td>{{ totais.desconto_afiliado | moeda }}</td>
                <v-spacer></v-spacer>
                <td>{{ totais.valor_total | moeda }}</td>
                <v-spacer></v-spacer>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import DateTimePicker from "@/components/forms/DateTimePicker.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import dayjs from "dayjs";
export default {
  components: {
    DateTimePicker,
    BaseButton,
  },
  props: {
    idafiliado: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dayjs: dayjs,
      filter: {
        initDateTime: "",
        endDateTime: "",
      },
    };
  },
  computed: {
    ...mapGetters([
      "allAffiliateDetail",
      "affiliateDetailLoading",
      "storeSequencial",
      "dialogAffiliateDetail",
    ]),
    headers() {
      return [
        {
          text: this.$t("reports.sales-by-affiliate.network-name"),
          align: "start",
          value: "nome_programa",
        },
        {
          text: this.$t("reports.sales-by-event.event"),
          align: "start",
          value: "descricao_produto",
        },
        {
          text: this.$t("reports.sales-by-affiliate.commission"),
          align: "end",
          value: "comissao_afiliado",
        },
        {
          text: this.$t("reports.sales-by-affiliate.discount"),
          align: "end",
          value: "desconto_afiliado",
        },
        { text: this.$t("reports.quantity"), align: "end", value: "qtd_itens" },
        {
          text: this.$t("reports.sales-by-affiliate.total-value"),
          align: "end",
          value: "valor_total",
        },
      ];
    },
  },
  methods: {
    ...mapActions(["fetchAffiliateDetail"]),
    ...mapMutations([
      "setAffiliateDetailLoading",
      "setReportsFilter",
      "setDialogAffiliateDetail",
    ]),
    filterByAffiliate() {
      this.setAffiliateDetailLoading(true);
      let filter = {};

      if (this.idafiliado) {
        Object.assign(filter, {
          idafiliado: this.idafiliado,
        });
      }
      if (this.filter.initDateTime) {
        Object.assign(filter, {
          dthr_pedi_ini: this.filter.initDateTime,
        });
      }

      if (this.filter.endDateTime) {
        Object.assign(filter, {
          dthr_pedi_fim: this.filter.endDateTime,
        });
      }

      Object.assign(filter, {
        loja: this.storeSequencial,
      });

      this.fetchAffiliateDetail(filter);
      this.setReportsFilter(filter);
    },
    handleInitDateTime(formatteddatetime) {
      this.filter.initDateTime = formatteddatetime;
    },
    handleEndDateTime(formatteddatetime) {
      this.filter.endDateTime = formatteddatetime;
    },
    openDialog() {
      this.setDialogAffiliateDetail(true);
    },
    closeDialog() {
      this.setDialogAffiliateDetail(false);
    },
  },
  watch: {
    dialogAffiliateDetail(val) {
      if (!val) {
        this.filter = {
          initDateTime: "",
          endDateTime: "",
        };
      }
    },
  },
};
</script>
